<template>
	<div class="main-view" id="main-h">
		<div class="video-start-main">
			<div class="v-tree">
				<p>摄像头选择</p>
				<el-tree :data="regionList" @node-click="handleNodeClick"></el-tree>
			</div>
			<div id="video-sreen"></div>
		</div>
<!-- 		
		<el-drawer title="地区选择" :visible.sync="drawer" :with-header="true" :direction="direction" :show-close="false"
			:size="switchSize">
			
		</el-drawer>
		<!-- 	<el-button @click="drawer = true" type="primary" style="margin-left: 16px;">
			点我打开
		</el-button> -->
		<!-- <img src="../../public/img/youbian.png" id="youbian" @click="drawer = true"> --> -->
	</div>
</template>

<script>
		import EZUIKit from 'ezuikit-js';
	export default {
		name: "deviceMenu",
		components: {
		
			
		},
		data() {
			return {
				drawer: false,
				areaId: "",
				direction: 'ltr',
				switchSize: 200,
				regionList: [],
				
			}
		},
		methods: {
			handleNodeClick(data) {
				if(data.children.length==0){
					let that = this;
					console.log(data);
					// if(JSON.stringify(that.player) != '{}'){
					// 	console.log("==============");
					// 	that.player.stop();
					// }
					if(that.player != undefined){
						console.log("==============");
							that.player.stop();
					}
				
				let div = document.getElementById("video-sreen");
				let vH = div.offsetHeight;
				let vW = div.offsetWidth;
					console.log(vH+"==="+vW);
					that.$axios({
						method: 'post',
						url: '/camer/startUrl',
						data: {
							deviceSerial: data.deviceSerial,
							quality: '1'
						}
					}).then(function(respose) {
					
						if (respose.code == "1") {
							let content = respose.content;
							let url = content.url;
							let token = content.token;
					
						
							that.player = new EZUIKit.EZUIKitPlayer({
								id:"video-sreen", // 视频容器ID
								accessToken: token,
								url: url,
								width: vW,
								height: vH,
								plugin: ["talk"],
								themeData: {
									"autoFocus": 5,
									"poster": "https://resource.eziot.com/group1/M00/00/89/CtwQEmLl8r-AZU7wAAETKlvgerU237.png",
									"header": {
										"color": "#1890ff",
										"activeColor": "#FFFFFF",
										"backgroundColor": "#000000",
										"btnList": [{
												"iconId": "deviceID",
												"part": "left",
												"defaultActive": 0,
												"memo": "顶部设备名称",
												"isrender": 1
											},
											{
												"iconId": "deviceName",
												"part": "left",
												"defaultActive": 0,
												"memo": "顶部设备ID",
												"isrender": 1
											},
											{
												"iconId": "cloudRec",
												"part": "right",
												"defaultActive": 0,
												"memo": "头部云存储回放",
												"isrender": 0
											},
											{
												"iconId": "rec",
												"part": "right",
												"defaultActive": 0,
												"memo": "头部本地回放",
												"isrender": 0
											}
										]
									},
									"footer": {
										"color": "#FFFFFF",
										"activeColor": "#1890FF",
										"backgroundColor": "#00000021",
										"btnList": [{
												"iconId": "play",
												"part": "left",
												"defaultActive": 1,
												"memo": "播放",
												"isrender": 1
											},
											{
												"iconId": "capturePicture",
												"part": "left",
												"defaultActive": 0,
												"memo": "截屏按钮",
												"isrender": 1
											},
											{
												"iconId": "sound",
												"part": "left",
												"defaultActive": 0,
												"memo": "声音按钮",
												"isrender": 1
											},
											{
												"iconId": "pantile",
												"part": "left",
												"defaultActive": 0,
												"memo": "云台控制按钮",
												"isrender": 1
											},
											{
												"iconId": "recordvideo",
												"part": "left",
												"defaultActive": 0,
												"memo": "录制按钮",
												"isrender": 1
											},
											{
												"iconId": "talk",
												"part": "left",
												"defaultActive": 0,
												"memo": "对讲按钮",
												"isrender": 1
											},
											{
												"iconId": "zoom",
												"part": "left",
												"defaultActive": 0,
												"memo": "电子放大",
												"isrender": 1
											},
											{
												"iconId": "hd",
												"part": "right",
												"defaultActive": 0,
												"memo": "清晰度切换按钮",
												"isrender": 1
											},
											{
												"iconId": "webExpend",
												"part": "right",
												"defaultActive": 0,
												"memo": "网页全屏按钮",
												"isrender": 1
											},
											{
												"iconId": "expend",
												"part": "right",
												"defaultActive": 0,
												"memo": "全局全屏按钮",
												"isrender": 1
											}
										]
									}
								}
							})
						
							// that.playerList.push(player);
					
						}
					}).catch(function(error) {
					
					
					});
				}
			},
			getAreaList() {
				let that = this;

				this.$axios({
					method: 'post',
					url: '/camer/getMenuList',
					data: {
						
					}
				}).then(function(respose) {
					let json = respose;
					if (json.code == 1) {
						let info = json.content;

						that.regionList = info;

					}


				}).catch(function(error) {

				});
			},
		},
		mounted() {
	
			this.getAreaList();
		}
	}
</script>

<style>
</style>
